import _ from 'lodash/fp'
import gql from 'graphql-tag'
import { all, call, put, takeLatest } from 'redux-saga/effects'

import { types, actions } from '../reducers/countries'
import { apolloClient } from '@fe/business/src/apollo'

//  ███████╗███████╗███████╗███████╗ ██████╗████████╗███████╗
//  ██╔════╝██╔════╝██╔════╝██╔════╝██╔════╝╚══██╔══╝██╔════╝
//  █████╗  █████╗  █████╗  █████╗  ██║        ██║   ███████╗
//  ██╔══╝  ██╔══╝  ██╔══╝  ██╔══╝  ██║        ██║   ╚════██║
//  ███████╗██║     ██║     ███████╗╚██████╗   ██║   ███████║
//  ╚══════╝╚═╝     ╚═╝     ╚══════╝ ╚═════╝   ╚═╝   ╚══════╝

const COUNTRIES_QUERY = gql`
  query Countries {
    countries {
      code
      name
    }
  }
`

function * loadCountriesEffect () {
  try {
    const response = yield call([apolloClient, apolloClient.query], {
      query: COUNTRIES_QUERY,
      fetchPolicy: 'network-only'
    })
    return _.getOr([], 'data.countries', response)
  } catch (error) {
    return { error }
  }
}

//  ███████╗ █████╗  ██████╗  █████╗ ███████╗
//  ██╔════╝██╔══██╗██╔════╝ ██╔══██╗██╔════╝
//  ███████╗███████║██║  ███╗███████║███████╗
//  ╚════██║██╔══██║██║   ██║██╔══██║╚════██║
//  ███████║██║  ██║╚██████╔╝██║  ██║███████║
//  ╚══════╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝╚══════╝

export function * loadFlow () {
  const result = yield call(loadCountriesEffect)
  if (result.error) {
    yield put(actions.loadError(result))
  } else {
    yield put(actions.loadSuccess(result))
  }
}

export default function * () {
  return yield all([
    takeLatest(types.LOAD_REQUEST, loadFlow)
  ])
}
